import attListIconsView from './attListIconsComponent.html';
import './attListIconsComponent.css';
import _ from 'lodash';
import { AuthTypes } from '../../../auth/AuthTypes';

import PostAction from '../../../../../../a-react-app/src/_common/domain/enums/PostAction';

export function attListIconsComponent() {
	return {
		bindings: {
			post: '<',
		},
		controllerAs: 'vm',
		controller: attListIconsComponentCtrl,
		template: attListIconsView,
	};
}

export class attListIconsComponentCtrl {
	constructor(Att, Api, EventTracker, modal) {
		'ngInject';
		this.Att = Att;
		this.Api = Api;
		this.EventTracker = EventTracker;
		this.modal = modal;
		this.maxIcons = 3;
	}

	$onInit() {
		angular.element(window).on(
			'resize',
			_.throttle(
				() => {
					this.getActionText();
				},
				150,
				{ leading: false, trailing: true }
			)
		);
		this.getActionText();

		this.canDownload = this.post.allowedActions.includes(PostAction.Download);
	}

	getActionText() {
		this.actionText = this.Att.getActionText();
	}

	preview(startIndex) {
		// if we are at a story board, also record click in story_board_clicks table
		const board = AuthTypes.getBoardHash();
		if (board) {
			const params = {
				post_id: this.post.id,
			};
			//record story click
			this.Api.post(`/story_boards/${board}/click`, params);
		}
		//We want clicking "preview" to also count as a post view
		const source = document.title.replace(' :: Sharpr', '');
		this.EventTracker.save('post_view', {
			post_id: this.post.id,
			source,
		});
		this.modal.iframe(
			`${window.BASE_URL}/core/posts/${this.post.id}/attachment?headline=${this.post.headline}&attachment_count=${this.post.attachment_count}&start_index=${startIndex}`,
			{
				heading: this.post.headline,
				width: 'full',
				height: 'full',
				padded: false,
			}
		);
	}
}
